/** URLまとめ */
export const urls = {
  line: 'https://lin.ee/iu58zru',
  twitter: 'https://twitter.com/intent/follow?screen_name=niconicoq_live',

  /** @see: https://atl.dwango.co.jp/confluence/pages/viewpage.action?pageId=139094216#id-%E3%82%A2%E3%83%97%E3%83%AA%E3%82%A4%E3%83%B3%E3%82%B9%E3%83%88%E3%83%BC%E3%83%AB%7C%E3%82%A2%E3%83%97%E3%83%AA%E8%B5%B7%E5%8B%95%E5%B0%8E%E7%B7%9A%E9%9B%86%E8%A8%88-2019/12/18.1 */
  appStore: 'https://itunes.apple.com/app/apple-store/id823479272?pt=13724&ct=tokusetsu_liveq_app_download&mt=8',

  /** @see: https://atl.dwango.co.jp/confluence/pages/viewpage.action?pageId=139094216#id-%E3%82%A2%E3%83%97%E3%83%AA%E3%82%A4%E3%83%B3%E3%82%B9%E3%83%88%E3%83%BC%E3%83%AB%7C%E3%82%A2%E3%83%97%E3%83%AA%E8%B5%B7%E5%8B%95%E5%B0%8E%E7%B7%9A%E9%9B%86%E8%A8%88-2019/12/18.1 */
  googlePlay:
    'https://play.google.com/store/apps/details?id=jp.co.dwango.nicocas&referrer=utm_source%3Dtokusetsu%26utm_medium%3Dliveq%26utm_campaign%3Dapp_download',
};
